import { Interval } from "luxon";
import * as Yup from "yup";

import { getLuxonDateTime } from "../../../utils/dateFormatter";
import {
  dateValidation,
  isFirstDateAfterSecondDate,
} from "../../../utils/yupValidation";
import { RequirementsAndActivityFormValues } from "./types";

const MAX_PROCESS_DATE_INTERVAL = 7;

const requirementsAndActivityFormSchema: Yup.SchemaOf<RequirementsAndActivityFormValues> =
  Yup.object().shape({
    requirementType: Yup.string(),
    fromProcessDate: dateValidation()
      .test(
        "max days",
        `Maximum ${MAX_PROCESS_DATE_INTERVAL} days`,
        (value, context) => {
          const interval = dateInterval(value, context.parent.toProcessDate);

          if (interval) {
            return interval <= MAX_PROCESS_DATE_INTERVAL;
          }
          return true;
        }
      )
      .required("Required"),
    toProcessDate: dateValidation()
      .test(
        "from must be before to date",
        "Invalid date pair",
        (value, context) =>
          isFirstDateAfterSecondDate(value, context.parent.fromProcessDate)
      )
      .required("Required"),
  });

export function dateInterval(
  firstDate?: string | Date,
  secondDate?: string | Date
): number | undefined {
  if (!firstDate) return;
  if (!secondDate) return;
  const startDate = getLuxonDateTime(firstDate);
  const endDate = getLuxonDateTime(secondDate);

  if (startDate && endDate && startDate < endDate) {
    const i = Interval.fromDateTimes(startDate, endDate);
    return i.length("days");
  }
  return;
}

export default requirementsAndActivityFormSchema;
